import { atom } from 'jotai';
import { DateTime } from 'luxon';

const todayDay = DateTime.now();
export const selectedDayAtom = atom<DateTime>(todayDay);

const bookedRoomsCount = null;
export const bookedRoomsCountAtom = atom<number | null>(bookedRoomsCount);
